import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Products = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    // Redirect to debit page by default
    navigate('/productdebit');
  }, [navigate]);
  
  return null;
};

export default Products;